const outOfStock = '/events/rootstech-store'
const storeConfig = {
  to: outOfStock, // 'https://rootstechonlinestore2026.itemorder.com/shop/home/',
}

export default storeConfig
